<template>
  <div class="mby-wrapper">
    <!-- Map -->
    <ThreatenedSpeciesMap id="mby-top"></ThreatenedSpeciesMap>

    <!-- Electorate Details -->
    <ElectorateDetails :gradesPopupLink="gradesPopupLink"></ElectorateDetails>

    <SpeciesDetails
      id="species-details"
      class="mby-species-details"
      :datalayerName="datalayerName"
      :programName="programName"

      :sendToIve="sendToIve"
      :iveSupplier="iveSupplier"
      :iveSource="iveSource"
      :iveCampaignId="iveCampaignId"

      :messageId="messageId"
      :cards="cards"
      :thankYouUrl="thankYouUrl"
      :privacyPolicyUrl="privacyPolicyUrl"
      :recovery-grade-status-title="recoveryGradeStatusTitle"
      :recovery-grade-status-subtitle="recoveryGradeStatusSubtitle"
      :recovery-grade-status-legend="recoveryGradeStatusLegend"
      :recovery-grade-status-description="recoveryGradeStatusDescription"
      :display-progress-numbers-title="displayProgressNumbersTitle"
      :display-progress-numbers-sigup-message="
        displayProgressNumbersSigupMessage
      "
      :display-progress-numbers-goal-message="displayProgressNumbersGoalMessage"
      :display-progress-numbers-petition-goal="
        displayProgressNumbersPetitionGoal
      "
      :form-header-title="formHeaderTitle"
      :form-supporter-details-title="formSupporterDetailsTitle"
      :form-supporter-details-subtitle="formSupporterDetailsSubtitle"
    ></SpeciesDetails>

    <!-- Disclaimer -->
    <p class="mby-disclaimer">
      We acknowledge the First Nations language groups mentioned in the My
      Backyard tool as the holders of their language and cultural knowledge.
    </p>

    <ThreatenedSpeciesModal
      :datalayer-name="datalayerName"
      :petition-goal="displayProgressNumbersPetitionGoal"
      :title="threatenedSpeciesModalTitle"
      :subtitle="threatenedSpeciesModalSubtitle"
      :description-line1="threatenedSpeciesModalDescriptionLine1"
      :description-line2="threatenedSpeciesModalDescriptionLine2"
    ></ThreatenedSpeciesModal>

    <!-- Other species popup -->
    <OtherSpeciesPopup></OtherSpeciesPopup>
  </div>
</template>

<script>
import SpeciesDetails from "./SpeciesDetails.vue";
import ElectorateDetails from "./ElectorateDetails.vue";
import ThreatenedSpeciesMap from "./ThreatenedSpeciesMap.vue";
import ThreatenedSpeciesModal from "./ThreatenedSpeciesModal.vue";
import OtherSpeciesPopup from "./OtherSpeciesPopup.vue";

export default {
  name: "ThreatenedSpecies",
  components: {
    SpeciesDetails,
    ElectorateDetails,
    ThreatenedSpeciesMap,
    OtherSpeciesPopup,
    ThreatenedSpeciesModal,
  },
  props: {
    // -- Electorate Details related props
    gradesPopupLink: {
      type: String,
      default: "https://www.wwf.org.au/",
    },
    // -- END

    // -- SpeciesDetails related props
    datalayerName: {
      type: String,
      required: true,
    },

    // MARKETO
    programName: {
      type: String,
      required: true,
    },

    sendToIve: {
      type: Boolean,
      default: false,
    },
    iveSupplier: {
      type: String,
      required: false,
    },
    iveSource: {
      type: String,
      required: false,
    },
    iveCampaignId: {
      type: String,
      required: false,
    },

    messageId: {
      type: String,
    },

    cards: {
      type: Array,
      default: () => [
        {
          pictureUrl: "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4796/dist/assets/img/my-backyard-landing-image-1.jpg",
          title: "Our wildlife is uniquely Australian",
          description:
            "Australia is home to an incredible array of threatened wildlife found nowhere else in the world",
        },
        {
          pictureUrl: "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4796/dist/assets/img/my-backyard-landing-image-2.jpg",
          title: "1,800 animals and plants are at risk of extinction",
          description:
            "Sadly, iconic wildlife, including east coast koalas and the greater glider, are at risk of disappearing forever",
        },
        {
          pictureUrl: "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4796/dist/assets/img/my-backyard-landing-image-3.jpg",
          title: "Protecting our wildlife and wild places",
          description:
            "To bring our wildlife back from the brink of extinction, we need stronger national nature laws that protect them and the places they call home. Add your voice today and make an impact",
        },
      ],
    },

    thankYouUrl: {
      type: String,
      default: "https://wwf.org.au/thank-you-for-making-a-difference/",
    },

    privacyPolicyUrl: {
      type: String,
      default: "https://wwf.org.au/about-us/privacy-policy/",
    },
    recoveryGradeStatusTitle: {
      type: String,
    },
    recoveryGradeStatusSubtitle: {
      type: String,
    },
    recoveryGradeStatusLegend: {
      type: String,
    },
    recoveryGradeStatusDescription: {
      type: String,
    },
    threatenedSpeciesModalTitle: {
      type: String,
    },
    threatenedSpeciesModalSubtitle: {
      type: String,
    },
    threatenedSpeciesModalDescriptionLine1: {
      type: String,
    },
    threatenedSpeciesModalDescriptionLine2: {
      type: String,
    },
    displayProgressNumbersTitle: {
      type: String,
    },
    displayProgressNumbersSigupMessage: {
      type: String,
    },
    displayProgressNumbersGoalMessage: {
      type: String,
    },
    displayProgressNumbersPetitionGoal: {
      type: Number,
      default: 10000,
    },
    formHeaderTitle: {
      type: String,
      required: true,
    },
    formSupporterDetailsTitle: {
      type: String,
      required: true,
    },
    formSupporterDetailsSubtitle: {
      type: String,
      required: true,
    },
    // -- END
  },
};
</script>

<style scoped>
/* Hidden overflow to get rid of double scrolling within the iframe on live */
.mby-wrapper {
  overflow: hidden;
}

@media screen and (min-width: 1250px) {
  .mby-wrapper {
    height: 100%;
  }
}

/* Species details in the middle */
.mby-species-details {
  position: relative;
  top: -250px;
  padding-top: 50px;
}
@media screen and (max-width: 1250px) {
  .mby-species-details {
    top: -330px;
  }
}
@media only screen and (max-width: 64em) {
  .mby-species-details {
    padding-top: 40px;
  }
}

/* Disclaimer */
.mby-disclaimer {
  text-align: center;
  top: -220px;
  margin-bottom: -200px;
}

@media screen and (max-width: 1250px) {
  .mby-disclaimer {
    top: -310px;
    margin-bottom: -290px;
  }
}

/* Style from elcom */
p {
  font-family: "Lato", sans-serif;
  position: relative;
  margin: 0;
  font-size: 16px;
}

@media only screen and (max-width: 40em) {
  p {
    font-size: 15px;
    line-height: 23px;
  }
}
/* END */
</style>



// WEBPACK FOOTER //
// ThreatenedSpecies.vue?0d435375